//GA dataLayer - Sprawdzenie fragmentu książki
(function ($) {
    $(".js-book-preview").on("click", function () {
        productName = $(this).attr("data-product_name");

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: "bookPreview",
            productName: productName,
        });
    });
})(jQuery);
